import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import { actions, selectors } from 'modules/debts';
import { actions as modalActions } from 'modules/modal';
import { selectors as userSelectors } from 'modules/user';

import DebtRainbow from './DebtRainbow';
import Loader from 'components/Loader';

class DebtRainbowContainer extends PureComponent {
  onBalanceAction = (transactionType, details) => {
    const { onInterest, onPayment, showModal } = this.props;
    showModal('amount', {
      details,
      transactionType,
      onClose: amt => {
        if (transactionType === 'payment') {
          onPayment(details, amt);
        } else {
          onInterest(details, amt);
        }
      },
    });
  };

  render() {
    const { loading, ...props } = this.props;

    if (loading) return <Loader />;

    return <DebtRainbow onBalanceAction={this.onBalanceAction} {...props} />;
  }
}

const mapStateToProps = state => ({
  debts: selectors.debts(state),
  loading: selectors.loading(state),
  settings: userSelectors.settings(state),
});

export default connect(mapStateToProps, {
  onInterest: actions.addInterest,
  onPayment: actions.addPayment,
  showModal: modalActions.showModal,
})(DebtRainbowContainer);



// WEBPACK FOOTER //
// ./src/components/DebtRainbow/DebtRainbow.container.js